import { Util } from "/global/js/util.min.js?v=1743070040";
import { t } from "/global/js/translations.min.js?v=1743070040";
const util = new Util();
export default class Product {
  constructor(isAdmin = 0) {
    this.ajaxHandler = '/content/plugins/shop/ajaxHandlerShop.php';
    this.isAdmin = isAdmin;
    pubsub.on("productSubCalendarOptionsShow", ([productElem, addToCartBtn]) => this.initProductsOptions(productElem, addToCartBtn));
    (async () => {
      this.t = await t;
      const productElems = document.querySelectorAll('.productData');
      if (!productElems) return;
      productElems.forEach(productElem => {
        const addToCartBtn = productElem.querySelector('.addToCartBtn');
        if (!addToCartBtn) return;
        addToCartBtn.addEventListener('click', () => this.onAddToCartBtnClick(addToCartBtn, productElem));
        const productQty = productElem.querySelector('.productQty');
        if (productQty) {
          productQty.addEventListener('input', () => this.onProductQtyChange(addToCartBtn, productQty));
        }
        this.extraInfos = productElem.querySelectorAll('.extraInfo');
        this.selectFromOpenHours = productElem.querySelector('.selectFromOpenHours');
        const dateRange = document.querySelector('.productDateRange');
        const dateRangeInputs = document.querySelector('.dateRangeInputs');
        if (dateRange) {
          const dateRangeDates = [];
          dateRangeInputs.querySelectorAll('input').forEach(input => {
            dateRangeDates.push(input.value);
          });
          const fp = flatpickr(dateRange, {
            inline: true,
            mode: 'range',
            minDate: 'today',
            allowInput: false,
            altInput: false,
            altFormat: this.t.country.counDateTimeFormat.date.medium,
            weekNumbers: true,
            enable: dateRangeDates,
            onValueUpdate: (selectedDates, dateStr, instance) => {
              productQty.value = 1;
              addToCartBtn.dataset.dateRange = '';
              if (selectedDates.length === 2) {
                const fromDate = new Date(instance.formatDate(selectedDates[0], "m/d/Y"));
                const toDate = new Date(instance.formatDate(selectedDates[1], "m/d/Y"));
                const oneDay = 24 * 60 * 60 * 1000; // Milliseconds in a day
                const diffInMs = Math.abs(toDate.getTime() - fromDate.getTime()); // Absolute difference in milliseconds
                const diffInDays = Math.round(diffInMs / oneDay); // Round to nearest whole number of days
                productQty.value = diffInDays;
                addToCartBtn.dataset.dateRange = encodeURIComponent(JSON.stringify({
                  fromDate: fromDate.yyyymmdd(),
                  toDate: toDate.yyyymmdd()
                }));
              }
              this.onProductQtyChange(addToCartBtn, productQty);
            }
          });
          if (dateRangeDates) {
            fp.jumpToDate(dateRangeDates[0]);
          }
        }
        this.initProductsOptions(productElem, addToCartBtn);
      });
      const style = document.createElement('style');
      style.innerHTML = `
                .flatpickr-days{
                    width: 100% !important;
                }
                
                .dayContainer{
                    max-width: none;
                    min-width: auto;
                    width: 100%;
                }
                
                .flatpickr-weeks{
                    height: calc(100% - 32px)
                }
                
                .flatpickr-weeks .flatpickr-day{
                    display: grid !important;
                    place-items: center;
                }
       
                .dayContainer .flatpickr-day{
                    max-width: calc(100% / 7);
                    aspect-ratio: 4/3;
                    display: grid;
                    place-items: center;
                }
                
                .flatpickr-day.inRange,
                .flatpickr-day.prevMonthDay.inRange,
                .flatpickr-day.nextMonthDay.inRange,
                .flatpickr-day.today.inRange,
                .flatpickr-day.prevMonthDay.today.inRange,
                .flatpickr-day.nextMonthDay.today.inRange,
                .flatpickr-day:hover,
                .flatpickr-day.prevMonthDay:hover,
                .flatpickr-day.nextMonthDay:hover,
                .flatpickr-day:focus,
                .flatpickr-day.prevMonthDay:focus,
                .flatpickr-day.nextMonthDay:focus{
                    background: ${this.t?.themeSettings?.general?.primaryBackgroundColor ?? ''};
                    border-color: ${this.t?.themeSettings?.general?.primaryBackgroundColor ?? ''};
                }
                
                .flatpickr-day.inRange{
                    box-shadow: -10px 0 0 ${this.t?.themeSettings?.general?.primaryBackgroundColor ?? ''};
                }
                
                .flatpickr-day.selected,
                .flatpickr-day.startRange,
                .flatpickr-day.endRange,
                .flatpickr-day.selected.inRange,
                .flatpickr-day.startRange.inRange,
                .flatpickr-day.endRange.inRange,
                .flatpickr-day.selected:focus,
                .flatpickr-day.startRange:focus,
                .flatpickr-day.endRange:focus,
                .flatpickr-day.selected:hover,
                .flatpickr-day.startRange:hover,
                .flatpickr-day.endRange:hover,
                .flatpickr-day.selected.prevMonthDay,
                .flatpickr-day.startRange.prevMonthDay,
                .flatpickr-day.endRange.prevMonthDay,
                .flatpickr-day.selected.nextMonthDay,
                .flatpickr-day.startRange.nextMonthDay,
                .flatpickr-day.endRange.nextMonthDay{
                    background: ${this.t?.themeSettings?.general?.primaryBackgroundColor ?? ''};
                    border-color: ${this.t?.themeSettings?.general?.primaryBackgroundColor ?? ''};
                }
                
                .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),
                .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),
                .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)){
                    box-shadow: -10px 0 0 ${this.t?.themeSettings?.general?.primaryBackgroundColor ?? ''};
                }
                
                .flatpickr-day.week.selected{
                    box-shadow: -10px 0 0 ${this.t?.themeSettings?.general?.primaryBackgroundColor ?? ''};
                }
            `;
      document.head.append(style);
      if (this.t.activePlugins.includes('openHours') && this.selectFromOpenHours) {
        import("/content/plugins/openHours/js/productCalendar.min.js?v=1743070023").then(ProductCalendar => this.productCalendar = new ProductCalendar.default());
      }
    })();
  }
  async onAddToCartBtnClick(btn, productElem) {
    //Stop script if element does not have these data attributes
    if (!util.parentsHasAttribute(btn, 'data-product-id') || !util.parentsHasAttribute(btn, 'data-product-sub-id') || !util.parentsHasAttribute(btn, 'data-product-qty') || !util.parentsHasAttribute(btn, 'data-department-id')) {
      return false;
    }
    if (productElem) {
      const productQtyElem = productElem.querySelector('.productQty');
      const productsOptionsQuantity = productElem.querySelectorAll('.js-productsOptionsQuantity');
      if (productsOptionsQuantity && productsOptionsQuantity.length > 0) {
        let optionQtyTotal = 0;
        for (const optionQty of productsOptionsQuantity) {
          const inputField = optionQty.querySelector('input[type=number]');
          if (inputField) {
            optionQtyTotal += parseInt(inputField.value);
          }
          if (inputField && inputField.min && parseInt(inputField.value) < parseInt(inputField.min)) {
            inputField.classList.add('border-danger');
            pubsub.trigger('error', {
              errorMsg: this.t.__('You must buy at least %s pieces', inputField.min)
            });
            return false;
          }
          if (inputField && inputField.max && parseInt(inputField.value) > parseInt(inputField.max)) {
            inputField.classList.add('border-danger');
            pubsub.trigger('error', {
              errorMsg: this.t.__('You cannot buy more than %s pieces', inputField.max)
            });
            return false;
          }
        }
        if (optionQtyTotal === 0) {
          pubsub.trigger('error', {
            errorMsg: this.t.__('Quantity must be filled in')
          });
          return false;
        }
        if (productQtyElem) {
          if (productQtyElem.min && optionQtyTotal < productQtyElem.min) {
            pubsub.trigger('error', {
              errorMsg: this.t.__('You must buy at least %s pieces in total', productQtyElem.min)
            });
            return false;
          }
          if (productQtyElem.max && optionQtyTotal > productQtyElem.max) {
            pubsub.trigger('error', {
              errorMsg: this.t.__('You cannot buy more than %s pieces in total', productQtyElem.max)
            });
            return false;
          }
        }
      }
    }
    if (btn.hasAttributes('data-date-range') && btn.dataset.dateRange === '') {
      pubsub.trigger('error', {
        errorMsg: this.t.__('Choose a date')
      });
      return false;
    }
    if (this.t.activePlugins.includes('openHours') && this.selectFromOpenHours) {
      //Validate selected date and attach it to the btn
      if (!btn === this.productCalendar.setDatetime(btn)) {
        return false;
      }
    }
    const formData = new FormData();
    if (this.extraInfos) {
      let checkExtraInfoFields = true;
      this.extraInfos.forEach(extraInfo => {
        if (util.parentsHasAttribute(extraInfo, 'required') && extraInfo.value === '') {
          extraInfo.classList.add('is-invalid');
          checkExtraInfoFields = false;
        }
        const checkBoxValue = [];
        if (extraInfo.classList.contains('extraInfoCheckbox')) {
          const checkBoxes = extraInfo.querySelectorAll(".form-check");
          checkBoxes.forEach(checkBox => {
            const formCheckInput = checkBox.querySelector('.form-check-input');
            if (formCheckInput.checked) {
              checkBoxValue.push(formCheckInput.value);
            }
          });
        }
        let extraInfoValue = '';
        if (checkBoxValue.length > 0) {
          extraInfoValue = checkBoxValue.join(', ');
        } else if (extraInfo.value) {
          extraInfoValue = extraInfo.value;
        }
        if (extraInfo.dataset.fieldName && extraInfoValue) {
          formData.append('extraInfo[' + extraInfo.dataset.fieldId + '][fieldName]', extraInfo.dataset.fieldName);
          formData.append('extraInfo[' + extraInfo.dataset.fieldId + '][fieldValue]', extraInfoValue);
        }
      });
      if (!checkExtraInfoFields) {
        return false;
      }
      this.extraInfos.forEach(extraInfo => {
        extraInfo.classList.remove('is-invalid');
        extraInfo.value = '';
      });
    }
    const dataObj = Object.entries(btn.dataset);
    for (const [key, value] of dataObj) {
      formData.append(key, value);
    }
    formData.append('isAdmin', this.isAdmin);
    if (formData.get('productId') === "") {
      pubsub.trigger('errorAddToCart', {
        "errorType": "Missing productId"
      });
      return false;
    }
    if (formData.get('productSubId') === "" || formData.get('productSubId') === "false") {
      pubsub.trigger('errorAddToCart', {
        "errorType": "Missing productSubId"
      });
      return false;
    }
    if (formData.get('productQty') === "") {
      pubsub.trigger('errorAddToCart', {
        "errorType": "Missing productQty"
      });
      return false;
    }
    if (formData.get('departmentId') === "") {
      pubsub.trigger('errorAddToCart', {
        "errorType": "Missing departmentId"
      });
      return false;
    }
    if (parseInt(formData.get('productQty')) > 0) {
      // Ajax action
      if (util.isAdmin()) {
        formData.append('language', 'languageEditBackend');
      }
      const fetchData = await fetch(this.ajaxHandler + '?handler=addToCart', {
        method: 'POST',
        body: formData
      });
      const response = await fetchData.json();
      if (response.error) {
        pubsub.trigger('error', response);
        return false;
      }
      pubsub.trigger('addedToCart', [this, response]);
      return response;
    }
  }
  initProductsOptions(productElem, addToCartBtn) {
    const productsOptionsQuantity = productElem.querySelectorAll('.js-productsOptionsQuantity');
    const productsOptionsSupplemental = productElem.querySelectorAll('.js-productsOptionsSupplemental');
    this.productsOptionsChange(addToCartBtn, productsOptionsQuantity, productsOptionsSupplemental);
    productsOptionsQuantity.forEach(optionQty => optionQty.addEventListener('input', () => this.productsOptionsChange(addToCartBtn, productsOptionsQuantity, productsOptionsSupplemental)));
    productsOptionsSupplemental.forEach(optionSupplemental => optionSupplemental.addEventListener('input', () => this.productsOptionsChange(addToCartBtn, productsOptionsQuantity, productsOptionsSupplemental)));
  }
  onProductQtyChange(addToCartBtn, input) {
    addToCartBtn.dataset.productQty = input.value;
  }
  productsOptionsChange(addToCartBtn, productsOptionsQuantity, productsOptionsSupplemental) {
    const data = {
      "productsOptionsQuantity": [],
      "productsOptionsSupplemental": []
    };
    for (const optionQty of productsOptionsQuantity) {
      const optionData = {};
      const input = optionQty.querySelector('input');
      if (input) {
        optionData.propId = input.dataset.propId;
        optionData.optionQty = input.value;
        data.productsOptionsQuantity.push(optionData);
      }
    }
    for (const optionSupplemental of productsOptionsSupplemental) {
      const optionData = {};
      const input = optionSupplemental.querySelector('input');
      if (input) {
        optionData.propId = input.dataset.propId;
        optionData.optionQty = input.value;
        data.productsOptionsSupplemental.push(optionData);
      }
    }
    addToCartBtn.dataset.productsOptions = encodeURIComponent(JSON.stringify(data));
  }
}